import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    screener: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async list (context, payload) {
    var response = await API.adminScreener.list (payload);
    // set screeners in list
    context.commit ('set_list', {
      screeners: response.screeners,
    });
    return response;
  },
  async listVodEvents(context, payload){
    var response = await API.adminScreener.listVodEvents (payload);
    return response;
  },

  async listVodEventByIds(context, payload){
    var response = await API.adminScreener.listVodEventByIds (payload);
    return response;
  }
};

// getters
const getters = {
  getField,
  getScreener: state => id => {
    if (!state.list.data) {
      return null;
    }
    return state.list.data.find (screener => {
      return screener.id == id;
    });
  },
  isScreeningPaid: state => screening => {
    if (!screening) {
      return false;
    }
    return screening.monetization_enabled;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.screeners;
  },

  update_screener (state, payload) {
    state.list.data = [
      ...state.list.data.filter (
        screener => screener.id !== payload.screener.id
      ),
      payload.screener,
    ];
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
